// ============================================================
// WEBHOOK CONFIGURATION — set REACT_APP_N8N_WEBHOOK_BASE in .env
// ============================================================

import {
  buildN8nWebhookUrl,
  WEBHOOK_PATHS,
} from "./helpers/webhookConfig";

export const WEBHOOKS = {
  GET_QUESTION: buildN8nWebhookUrl(WEBHOOK_PATHS.GET_QUESTION),
  SUBMIT_ANSWER: buildN8nWebhookUrl(WEBHOOK_PATHS.SUBMIT_ANSWER),
};

export const DEFAULT_SESSION_ID = "session_001";
